/**
 * bcpo-color-image-sync.js
 * OutdoorCompany (Theme: Ride) + VO Product Options
 *
 * Objetivo:
 * - Cuando el usuario selecciona un COLOR, cambiar la imagen principal al media correspondiente,
 *   incluso si NO seleccionó talle.
 * - Evitar el “va y viene / duda / microsegundo” re-aplicando el cambio unas veces para ganarle a scripts del app.
 */

(function () {
  "use strict";

  // --- Config ---
  var COLOR_OPTION_NAMES = ["color", "colour", "colores", "colourway", "couleur"]; // por si alguna vez cambia
  var RETRY_DELAYS_MS = [0, 60, 220]; // re-aplicar para ganarle a VO / Ride / otros scripts
  var DEBUG = false; // ponelo en true si querés ver logs

  function log() {
    if (!DEBUG) return;
    // eslint-disable-next-line no-console
    console.log.apply(console, ["[color-image-sync]"].concat([].slice.call(arguments)));
  }

  function getHandleFromUrl() {
    try {
      var parts = window.location.pathname.split("/").filter(Boolean);
      var idx = parts.indexOf("products");
      if (idx !== -1 && parts[idx + 1]) return parts[idx + 1];
      return null;
    } catch (e) {
      return null;
    }
  }

  function fetchProductJson(handle) {
    return fetch("/products/" + handle + ".js", { credentials: "same-origin" })
      .then(function (r) {
        if (!r.ok) throw new Error("No se pudo cargar /products/" + handle + ".js");
        return r.json();
      });
  }

  function normalize(s) {
    return String(s || "").trim().toLowerCase();
  }

  function findColorOptionPosition(productJson) {
    if (!productJson || !productJson.options || !productJson.options.length) return null;

    for (var i = 0; i < productJson.options.length; i++) {
      var name = normalize(productJson.options[i].name);
      for (var j = 0; j < COLOR_OPTION_NAMES.length; j++) {
        if (name === COLOR_OPTION_NAMES[j]) return productJson.options[i].position; // 1-based
        // por si viene como "Color:" o "Color "
        if (name.indexOf(COLOR_OPTION_NAMES[j]) !== -1) return productJson.options[i].position;
      }
    }
    return null;
  }

  // Construye mapa: color -> { mediaId, availablePreferred }
  function buildColorToMediaMap(productJson, colorPos) {
    var map = {};
    if (!productJson || !productJson.variants || !colorPos) return map;

    productJson.variants.forEach(function (v) {
      var colorVal = v["option" + colorPos];
      if (!colorVal) return;

      // En .js, lo más útil es featured_media.id (coincide con data-target del thumbnail en Ride)
      var mediaId = v.featured_media && v.featured_media.id ? String(v.featured_media.id) : null;
      if (!mediaId) return;

      var key = String(colorVal).trim(); // respetamos mayúsculas del label
      var isAvailable = !!v.available;

      if (!map[key]) {
        map[key] = { mediaId: mediaId, availablePreferred: isAvailable };
        return;
      }

      // Preferir una variante "available" para ese color (si existe) sobre una agotada
      if (!map[key].availablePreferred && isAvailable) {
        map[key] = { mediaId: mediaId, availablePreferred: true };
      }
    });

    return map;
  }

  function findThumbnailButtonForMediaId(mediaId) {
    if (!mediaId) return null;

    // Ride usa: li.thumbnail-list__item[data-target="template--...-<mediaId>"]
    var selector = 'li.thumbnail-list__item[data-target$="-'+ CSS.escape(String(mediaId)) +'"] button';
    var btn = document.querySelector(selector);
    if (btn) return btn;

    // Fallbacks por si cambia markup
    btn = document.querySelector('[data-media-id="'+ CSS.escape(String(mediaId)) +'"] button');
    if (btn) return btn;

    // Otro fallback común
    btn = document.querySelector('button[aria-describedby*="'+ CSS.escape(String(mediaId)) +'"]');
    if (btn) return btn;

    return null;
  }

  function clickThumbnailByMediaId(mediaId) {
    var btn = findThumbnailButtonForMediaId(mediaId);
    if (!btn) {
      log("No encontré thumbnail para mediaId:", mediaId);
      return false;
    }
    btn.click();
    return true;
  }

  function getSelectedColorFromDom() {
    // 1) VO / BCPO (lo tuyo muestra .single-option-selector con radios)
    var checked = document.querySelector('.single-option-selector input[type="radio"]:checked');
    if (checked && checked.value) return checked.value;

    // 2) Variant pills nativos (por si algún producto no usa VO en ese bloque)
    checked = document.querySelector('variant-radios input[type="radio"]:checked');
    if (checked && checked.value) return checked.value;

    // 3) Dropdown nativo
    var sel = document.querySelector('variant-selects select[name^="options"], variant-selects select');
    if (sel && sel.value) return sel.value;

    return null;
  }

  function pickInitialColor(productJson, colorPos) {
    // Si ya hay un color seleccionado en UI, lo respetamos.
    var fromDom = getSelectedColorFromDom();
    if (fromDom) return fromDom;

    // Si no, elegimos el primer color que tenga alguna variante available
    if (productJson && productJson.variants && colorPos) {
      for (var i = 0; i < productJson.variants.length; i++) {
        var v = productJson.variants[i];
        if (v.available) {
          var c = v["option" + colorPos];
          if (c) return c;
        }
      }
      // Si ninguna available, usamos el primer color existente
      for (var k = 0; k < productJson.variants.length; k++) {
        var v2 = productJson.variants[k];
        var c2 = v2["option" + colorPos];
        if (c2) return c2;
      }
    }

    return null;
  }

  function applyColorImage(colorToMediaMap, colorValue) {
    if (!colorValue) return;

    // En VO suelen venir en MAYÚSCULAS; hacemos match tolerante:
    var wanted = String(colorValue).trim();
    var mediaId = null;

    if (colorToMediaMap[wanted]) {
      mediaId = colorToMediaMap[wanted].mediaId;
    } else {
      // Match case-insensitive por si el DOM trae "Negro" y JSON "NEGRO"
      var keys = Object.keys(colorToMediaMap);
      for (var i = 0; i < keys.length; i++) {
        if (normalize(keys[i]) === normalize(wanted)) {
          mediaId = colorToMediaMap[keys[i]].mediaId;
          break;
        }
      }
    }

    if (!mediaId) {
      log("No hay mediaId mapeado para color:", wanted);
      return;
    }

    // Re-aplicamos varias veces para evitar el “vuelve solo” o el “duda”
    RETRY_DELAYS_MS.forEach(function (ms) {
      window.setTimeout(function () {
        clickThumbnailByMediaId(mediaId);
      }, ms);
    });
  }

  function setupListeners(colorToMediaMap) {
    // Delegación para agarrar clicks aunque VO re-renderice el bloque
    document.addEventListener("click", function (e) {
      var t = e.target;

      // Si clickeó un label de VO, buscamos el input asociado
      if (t && t.tagName === "LABEL" && t.getAttribute("for")) {
        var inp = document.getElementById(t.getAttribute("for"));
        if (inp && inp.classList && inp.classList.contains("bcpo-front-button-option")) {
          applyColorImage(colorToMediaMap, inp.value);
          return;
        }
      }

      // Si clickeó directamente el input radio VO
      if (t && t.matches && t.matches('.single-option-selector input[type="radio"], .single-option-selector .bcpo-front-button-option')) {
        applyColorImage(colorToMediaMap, t.value);
        return;
      }

      // Variant pills nativos
      if (t && t.matches && t.matches('variant-radios input[type="radio"]')) {
        applyColorImage(colorToMediaMap, t.value);
        return;
      }
    }, true);

    // También en change (por si algún browser / app no dispara bien click)
    document.addEventListener("change", function (e) {
      var t = e.target;
      if (!t) return;

      if (t.matches && t.matches('.single-option-selector input[type="radio"], variant-radios input[type="radio"]')) {
        applyColorImage(colorToMediaMap, t.value);
      }
    }, true);
  }

  function init() {
    var handle = getHandleFromUrl();
    if (!handle) return;

    fetchProductJson(handle)
      .then(function (productJson) {
        var colorPos = findColorOptionPosition(productJson);
        if (!colorPos) {
          log("No encontré opción Color en product.options");
          return;
        }

        var colorToMediaMap = buildColorToMediaMap(productJson, colorPos);
        log("Mapa color->media:", colorToMediaMap);

        // Aplicar en carga (sin pedir talle)
        var initialColor = pickInitialColor(productJson, colorPos);
        if (initialColor) {
          // Esperamos un toque a que Ride termine de montar la galería
          window.setTimeout(function () {
            applyColorImage(colorToMediaMap, initialColor);
          }, 120);
        }

        setupListeners(colorToMediaMap);
      })
      .catch(function (err) {
        log("Error init:", err);
      });
  }

  // Arranque
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
